import "./App.css";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { Suspense, lazy, useEffect, useLayoutEffect, useState } from "react";
import SplashVideo from "./components/Splash/splash";
import { HttpApisProvider } from "./Context/context";
import { NetworkProvider } from "./Context/NetworkContext";
import Spinner from "./components/Spinner/Spinner";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "abortcontroller-polyfill/dist/abortcontroller-polyfill-only";
// import 'shaka-player/dist/shaka-polyfill.ui.
// Lazy load components
// import 'shaka-player/dist/shaka-player.ui.js';
// import shaka from "shaka-player/dist/shaka-player.compiled.js";

const Login_Page = lazy(() => import("./components/Login/Login_Page"));
const Home = lazy(() => import("./components/Home_Page/home"));
const Search = lazy(() => import("./components/Search/Search"));
const DetailsPage = lazy(() => import("./components/DetailsPage/detailsPage"));
const WidevineVideoPlayer = lazy(() => import("./components/Player/player"));

const App = () => {
  const [loading, setloading] = useState(true);
  

  useEffect(() => {
    window.SpatialNavigation.init();
    
    return () => {
      window.SpatialNavigation.uninit();
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setloading(false);
    }, 6000);

    return () => clearTimeout(timer);
  }, []);

  const AppRouter = createHashRouter([
    {
      path: "/", // ✅ Default route - always Login
      element: <Login_Page />,
    },
    {
      path: "/home", // ✅ Home route - only when authenticated
      element: <Home />,
    },
    {
      path: "/search",
      element: <Search />,
    },
    {
      path: "/details/:id",
      element: <DetailsPage />,
    },
    {
      path: "/player/:id/:type/",
      element: <WidevineVideoPlayer />,
    },
  ]);

  return (
    <div style={{ position: loading ? "relative" : null }}>
      {loading && <SplashVideo />}
      <HttpApisProvider>
        <NetworkProvider>
          <Suspense fallback={<Spinner />}>
            <RouterProvider router={AppRouter} />
          </Suspense>
        </NetworkProvider>
      </HttpApisProvider>
    </div>
  );
};

export default App;
